<section class="product-details">

  <!-- COST BREAKDOWN -->
  @if (productInfo?.rateDetails?.applicants) {
    @for (applicant of applicants; track applicant; let i = $index) {
      <div class="member-row">
        <div class="title">
          <strong> Applicant #{{i + 1}}</strong><br>
          Relationship: {{ applicant.relationship }} <br>
          Date Of Birth: {{ formatDate(applicant.dob) }} <br>
          @if(showTobaccoStatus === true){
            {{tobaccoDisplay(applicant.tobaccoStatus)}} <br>
          }
        </div>
        <div class="value">
          <p>
            <strong> {{ applicant.rate | currency }} </strong>
            <span>Monthly Premium</span>
          </p>
        </div>
      </div>
    }
    <hr>
    }

    <!-- ANNUAL PREMIUM -->

    <div class="benefit">
      <div class="title">
        <h3>Monthly Premium For Family</h3>
        <p>
          Rates are subject to change and are based on information provided
        </p>
      </div>
      <div class="value"><strong>{{productInfo?.price | currency}}</strong>
      <p>
        x 12 months
      </p>
    </div>

  </div>

  <div class="benefit">
    <div class="title">
      <h3>Estimated Annual Premium</h3>
      <p>
        Estimated Annual Premium is based on plan enrollment for an entire calendar year.
      </p>
    </div>
    <div class="value"><strong>{{yearPremium}}</strong></div>

  </div>

  <!-- OOP Max -->
  @if (oopMax) {
    <div class="benefit">
      <div class="title">
        <h3>Out of pocket Maximum</h3>
        <p>
          The highest amount you will need to pay each benefit period (usually a year) for covered in-network
          care before your insurance company pays 100%. For example, if you pay 20% of your medical bills and your
          out of pocket maximum is $2000, once you have paid $2000 the insurance company pays for 100% of the
          plan allowance for covered in-network care. This does not include any services not covered by your plan.
        </p>
      </div>
      <div class="value">
        <p>{{oopMax}} </p>
      </div>
    </div>
  }

  <!-- Deductible -->
  @if (deductible) {
    <div class="benefit">
      <div class="title">
        <h3>Deductible</h3>
        <p class="note">
          The dollar amount you must pay each benefit period (usually a year) for your health care expenses
          before your plan begins to pay. For example, if you have a $500 deductible, that’s the amount you will pay
          before your provider will pay for service under your health coverage plan. Copayments are not included.
          <br>
          </p>
        </div>
        <div class="value">
          <p> {{deductible}} </p>
        </div>
      </div>
    }

    <!-- Co Insurance -->
    @if (coinsurance) {
      <div class="benefit">
        <div class="title">
          <h3>Coinsurance</h3>
          <p>
            Blue Cross pays the costs of a covered health care service, calculated as a percent (for
            example, 80%) of the allowed amount for the service. You pay coinsurance plus any deductibles you owe. For
            example, if the health insurance or plan’s allowed amount for an office visit is $100 and you’ve met your
            deductible, your coinsurance payment of 20% would be $20. The health insurance or plan pays the rest of the
            allowed amount.
          </p>
        </div>
        <div class="value">
          <p> {{coinsurance}} </p>
        </div>
      </div>
    }

  </section>